import { AfterViewInit, Component, ElementRef, OnDestroy, signal, viewChild, ChangeDetectionStrategy} from '@angular/core';
import { gsap } from 'gsap';
import {clearInterval} from "node:timers";

@Component({
    selector: 'gt-loading-indicator',
    templateUrl: './loading-indicator.component.html',
    styleUrls: ['./loading-indicator.component.scss'],
    changeDetection: ChangeDetectionStrategy.OnPush,
})
export class LoadingIndicatorComponent implements AfterViewInit, OnDestroy {
  readonly loadingIndicatorContainer = viewChild<ElementRef<HTMLDivElement>>('loadingIndicatorContainer');
  private animationTimeline: gsap.core.Timeline;

  private dotCount = 0;
  public loadingDotText = signal<string>('');

  ngAfterViewInit(): void {
    const paths = Array.from(this.loadingIndicatorContainer().nativeElement.querySelectorAll('path'));
    this.animationTimeline = gsap.timeline();
    this.animationTimeline.fromTo(paths, { drawSVG: '0' }, { duration: 6, drawSVG: '100%' });

    setInterval(() => {
      this.dotCount = (this.dotCount + 1) % 4; // cycles through 0 to 3
      this.loadingDotText.set('.'.repeat(this.dotCount));
    }, 500);
  }

  ngOnDestroy(): void {
    this.animationTimeline.kill();

  }
}
